import React from 'react'
import PropTypes from 'prop-types'
import FormInput from './FormInput'

const FormTextarea = ({
  rows,
  rowsMax,
  style,
  ...props
}) => (
  <FormInput
    style={{ marginLeft: 10, marginTop: 0, ...style }}
    {...props}
    rows={rows}
    rowsMax={rowsMax}
    multiLine
  />
)

FormTextarea.propTypes = {
  rows: PropTypes.number,
  rowsMax: PropTypes.number,
  style: PropTypes.object,
}
FormTextarea.defaultProps = {
  rows: 1,
  rowsMax: 4,
  style: {},
}

export default FormTextarea



// WEBPACK FOOTER //
// ./src/components/forms/bases/FormTextarea.js